module.exports = __webpack_public_path__ + "img/UserPersonalCards.17c0b9d9.svg";